import { organizationDetailSchema } from '@fluxus/shared';
import { useQuery } from '@tanstack/react-query';
import { ArrowLeft } from 'lucide-react';
import { Link, useParams } from 'react-router';
import { PageContainer, PageHeader } from '@/components/layout/PageHeader';
import { CompanyNav } from '@/features/organizations/CompanyNav';
import { UsersPanel } from '@/features/users/UsersPanel';
import { useAuth } from '@/lib/auth/session';

/** Usuários de uma empresa cliente (T-026c, RF-08): aba da empresa na Central de Empresas (DEC-019). */
export function UsuariosPage() {
  const { organizationId = '' } = useParams();
  const { client } = useAuth();
  const org = useQuery({
    queryKey: ['organizations', 'detail', organizationId],
    queryFn: ({ signal }) =>
      client.request(`/organizations/${organizationId}`, { schema: organizationDetailSchema, signal }),
  });

  return (
    <PageContainer className="max-w-5xl">
      <Link
        to={`/empresas/${organizationId}`}
        className="inline-flex items-center gap-1.5 text-sm font-semibold text-muted-foreground hover:text-foreground"
      >
        <ArrowLeft className="size-4" aria-hidden />
        {org.data?.name ?? 'Empresa'}
      </Link>
      <PageHeader
        className="mt-4"
        title="Usuários"
        description="Quem acessa o BSC da empresa, com qual perfil e em quais áreas e unidades. Cada pessoa entra por convite enviado ao e-mail dela."
      />
      <CompanyNav organizationId={organizationId} />
      <UsersPanel organizationId={organizationId} />
    </PageContainer>
  );
}
